// @ts-nocheck
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/pages/auth/Login";
import Register from "./components/pages/auth/Register";
import Home from "./components/pages/home/Home";
import PackageDetails from "./components/pages/sendParcel/packageDetails/PackageDetails";
import SupplierDetails from "./components/pages/sendParcel/supplierDetails/SupplierDetails";
import OrderSummary from "./components/pages/sendParcel/orderSummary/OrderSummary";
import ConsigneeDetails from "./components/pages/sendParcel/consigneeDetails/ConsigneeDetails";
import DestinationDetails from "./components/pages/sendParcel/destinationDetails/DestinationDetails";
import { ChakraProvider } from "@chakra-ui/react";
import Dashboard from "./components/pages/dashboard/Dashboard";
import MyOrders from "./components/pages/dashboard/MyOrders";
import { ToastContainer } from "react-toastify";
import ProtectedRoutes from "./Utils/ProtectedRoutes";
import OrderDetails from "./components/pages/dashboard/OrderDetails";
import OrderDetails2 from "./components/pages/dashboard/OrderDetails2";
import PaymentDetails from "./components/pages/dashboard/PaymentDetails";
import Reviews from "./components/pages/dashboard/Reviews";
import PlaceOrder from "./components/pages/sendParcel/placeOrder/PlaceOrder";
import ForgetPassword from "./components/pages/auth/ForgetPassword";
import OtpPage from "./components/pages/auth/OtpPage";
import NewPassword from "./components/pages/auth/NewPassword";
import ChangePassword from "./components/pages/auth/ChangePassword";
import UpdateProfile from "./components/pages/auth/UpdateProfile";
import PaymentSuccess from "./components/pages/sendParcel/payment/PaymentSuccess";
import PaypalPaymentSuccess from "./components/pages/sendParcel/payment/PaypalPyamentSuccess";
import Val from "./components/Validation";
import BeforePayment from "./components/pages/sendParcel/payment/BeforePayment";
import CompanyDetail from "./components/pages/sendParcel/company/CompanyDetail";
import EmailOtp from "./components/pages/auth/EmailOtp";
import VerifyEmail from "./components/pages/auth/VerifyEmail";
import Support from "./components/pages/Support/Support";
import Faqs from "./components/pages/faqs/Faqs";
import PaymentAndInvoice from "./components/pages/dashboard/PaymentAndInvoice";
import GettingStarted from "./components/pages/dashboard/GettingStarted";
import PayPalPaymentOptions from "./components/pages/dashboard/PayPalPaymentOptions";
import CardPage from "./components/pages/dashboard/CardPage";
import SuccessFullPayment from "./components/pages/sendParcel/payment/SuccessFullPayment";
import TermsConditions from "./components/pages/TermsConditions";
import Privacy from "./components/pages/Privacy";
import Dummy from "./components/pages/dashboard/Dummy";
import WayBillModal from "./components/pages/dashboard/WayBillModal";

export default function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <ToastContainer />
      <ChakraProvider>


        <Router>
          <Routes>
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/val" element={<Val />} />
            <Route exact path="/register" element={<Register />} />
            <Route exact path="/email_otp" element={<EmailOtp />} />
            <Route exact path="/forget_password" element={<ForgetPassword />} />
            <Route exact path="/verify_otp" element={<OtpPage />} />
            <Route exact path="/verify_email" element={<VerifyEmail />} />
            <Route exact path="/new_password" element={<NewPassword />} />
            <Route exact path="/change_password" element={<ChangePassword />} />
            <Route
              exact
              path="/"
              element={<Home />}
            />
            <Route
              exact
              path="/update_profile/:userId"
              element={<ProtectedRoutes Component={UpdateProfile} />}
            />

            <Route
              exact
              path="/package_details"
              element={<PackageDetails />}
            // element={<ProtectedRoutes Component={PackageDetails} />}
            />
            <Route
              exact
              path="/company_details"
              element={<ProtectedRoutes Component={CompanyDetail} />}
            />
            <Route
              exact
              path="/supplier_details"
              element={<ProtectedRoutes Component={SupplierDetails} />}
            />
            <Route
              exact
              path="/consignee_details"
              element={<ProtectedRoutes Component={ConsigneeDetails} />}
            />
            <Route
              exact
              path="/destination_details"
              element={<ProtectedRoutes Component={DestinationDetails} />}
            />
            <Route
              exact
              path="/order_summary"
              element={<ProtectedRoutes Component={OrderSummary} />}
            />
            <Route
              exact
              path="/place_order"
              element={<ProtectedRoutes Component={PlaceOrder} />}
            />
            <Route
              exact
              path="/dashboard"
              element={<ProtectedRoutes Component={Dashboard} />}
            />
            <Route
              exact
              path="/payment_and_invoices"
              element={<ProtectedRoutes Component={PaymentAndInvoice} />}
            />
            <Route
              exact
              path="/my_orders"
              element={<ProtectedRoutes Component={MyOrders} />}
            />
            <Route
              exact
              path="/order_details"
              element={<ProtectedRoutes Component={OrderDetails} />}
            />
            <Route
              exact
              path="/order_details2"
              element={<ProtectedRoutes Component={OrderDetails2} />}
            />
            <Route
              exact
              path="/before_payment"
              element={<ProtectedRoutes Component={BeforePayment} />}
            />
            <Route
              exact
              path="/payment_details"
              element={<ProtectedRoutes Component={PaymentDetails} />}
            />
            <Route
              exact
              path="/paypal_options"
              element={<ProtectedRoutes Component={PayPalPaymentOptions} />}
            />
            <Route
              exact
              path="/card"
              element={<ProtectedRoutes Component={CardPage} />}
            />
            <Route
              exact
              path="/payment_success"
              element={<ProtectedRoutes Component={PaymentSuccess} />}
            />
            <Route
              exact
              path="/paypal_payment_success"
              element={<ProtectedRoutes Component={PaypalPaymentSuccess} />}
            />
            <Route
              exact
              path="/successfull_payment"
              element={<ProtectedRoutes Component={SuccessFullPayment} />}
            />
            <Route
              exact
              path="/reviews"
              element={<ProtectedRoutes Component={Reviews} />}
            />
            <Route
              exact
              path="/support"
              element={<Support />}
            />
            <Route
              exact
              path="/faq"
              element={<Faqs />}
            />
            <Route
              exact
              path="/getting_started"
              element={<GettingStarted />}
            />
            <Route
              exact
              path="/terms_and_conditions"
              element={<TermsConditions />}
            />
            <Route
              exact
              path="/privacy_and_policy"
              element={<Privacy />}
            />
            <Route
              exact
              path="/dummy"
              element={<Dummy />}
            />

            <Route
              exact
              path="/waybill"
              element={<WayBillModal />}
            />
          </Routes>
        </Router>
      </ChakraProvider>
    </>
  );
}
